var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"fixed","right":"5px","top":"0.5em","z-index":"1000"}},_vm._l((_vm.Notificaciones),function(item,i){return _c('div',{key:i},[_c('Notificacion',{attrs:{"Tipo":item.Tipo,"Mensaje":item.Mensaje}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }